import { GetterTree } from 'vuex'
import { DistrModerationState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<DistrModerationState, RootState> = {
  bulkDistrList: (state) => {
    return state.bulkDistrList;
  },
  bulkDistrItem: (state) => {
    return state.bulkDistrItem;
  },
};